import { Injectable, signal, computed } from '@angular/core';
import { User, GoogleAuthProvider, signInWithRedirect, getRedirectResult, signOut, onAuthStateChanged } from 'firebase/auth';
import { getAuthInstance } from '../../../infrastructure/firebase.init';
import { environment } from '../../../environments/environment';
import { DataSource } from '../../../environments/environment.config';

const MOCK_USER = {
  uid: 'user-1',
  email: 'demo@flowcaja.com',
  displayName: 'Demo User',
  photoURL: null,
} as unknown as User;

@Injectable({ providedIn: 'root' })
export class AuthService {
  private _user = signal<User | null>(null);
  private _loading = signal(true);
  private _redirectError = signal<string | null>(null);

  readonly user = this._user.asReadonly();
  readonly loading = this._loading.asReadonly();
  readonly redirectError = this._redirectError.asReadonly();
  readonly isAuthenticated = computed(() => !!this._user());

  constructor() {
    if (environment.dataSource === DataSource.Mock) {
      this._user.set(MOCK_USER);
      this._loading.set(false);
    } else {
      const auth = getAuthInstance();

      getRedirectResult(auth)
        .catch((err) => this._redirectError.set(err.message ?? 'Sign-in failed.'))
        .finally(() => {
          onAuthStateChanged(auth, (firebaseUser) => {
            this._user.set(firebaseUser);
            this._loading.set(false);
          });
        });
    }
  }

  signInWithGoogle(): void {
    const auth = getAuthInstance();
    signInWithRedirect(auth, new GoogleAuthProvider());
  }

  async signOut(): Promise<void> {
    if (environment.dataSource === DataSource.Mock) {
      return;
    }
    const auth = getAuthInstance();
    await signOut(auth);
  }
}
